<template>
  <section v-on:click="bubbleOpen = false; openMenu = false; shareOpen = false;"
    v-on:touchstart="bubbleOpen = false">
    <button class="backBtn" v-on:click="goBack"><span>Kembali</span></button>
    <div class="sound withBack">
      <div :class="{soundBtn: true, on: audioPlaying}" v-on:click="$emit('play')"></div>
      <div class="soundLabel">
        Sound
        <span v-if="audioPlaying">On</span>
        <span v-else>Off</span>
      </div>
    </div>
    <div class="menuCnt">
      <div class="menuToggle" v-on:click.stop="openMenu = !openMenu"></div>
      <div :class="{menu: true, open: openMenu}" v-on:click.stop="doNothing">
        <div class="menuItem left" v-on:click="openDownload">Download Brosur</div>
        <div class="menuItem right" v-on:click="openFaq">FAQ</div>
      </div>
    </div>
    <div class="lHeader">
      <div class="leafL"></div><div class="leafR"></div>
      <div class="rumputL"></div><div class="rumputL rumputL2"></div>
      <div class="rumputR"></div><div class="rumputR rumputR2"></div>
    </div>
    <div :class="{title: true, an: titleAn}"></div>
    <div class="umang"></div><div class="star1"></div><div class="star2"></div>
    <div class="recommender" v-on:click.stop="toggleBubble"
      v-on:touchstart.stop="doNothing">
      <div :class="{bubble: true, open: bubbleOpen, an: bubbleAn, cnt: bubbleCnt}">
        <div class="close" v-on:click.stop="bubbleOpen = false"></div>
        <div class="bubbleContent">
          <p>Halo {{name}}!</p>
          <p>Kamu pasti mau punya kulit yang segar, cerah dan awet muda kan?
            Tapi bingung gimana caranya? Yuk optimalkan kulit cantik kamu
            dengan cara menjaga kolagen di tubuh kita.</p>
          <p>Solusi praktis beauty inside out bersama Nutrilite Mixed
            Collagen Drink dan Artistry Vita Collagen yang merupakan
            amunisi untuk kulitmu.</p>
          <p>Cara penggunaannya gampang banget! So, pastikan kamu pakai keduanya ya.</p>
        </div>
        <div class="arrow"></div><div class="arrow2"></div><div class="arrow3"></div>
      </div>
    </div>
    <div class="stages">
      <div class="stageItem stage1">
        <div class="videoCnt" v-on:click="playVideo('beauty-from-inside', true)"></div>
        <h4 v-on:click="playVideo('beauty', true)">Beauty From Inside</h4>
      </div>
      <div class="stageItem stage2">
        <div class="videoCnt" v-on:click="playVideo('beauty', false)"></div>
        <h4 v-on:click="playVideo('beauty', false)">Beauty From Outside</h4>
      </div>
      <div class="stageAction">
      </div>
      <div class="tide"></div><div class="tideBg"></div>
    </div>
    <div class="bolaPantai"></div><div class="payungB"></div>
    <div class="tide"></div><div class="tideBg"></div>
    <div class="copyright">
      <div class="shareFooter" :class="{open: shareOpen}"
        v-on:click.stop="shareOpen = !shareOpen"></div>
      <div class="socialLink" :class="{open: shareOpen}"
        v-on:click.stop="doNothing">
        <div class="sclLabel">Find Us On:</div>
        <a class="sclItem ig" target="_blank"
          href="https://www.instagram.com/nutrilite_id/"></a>
        <a class="sclItem fb" target="_blank"
          href="https://www.facebook.com/NutriliteID"></a>
        <a class="sclItem tw" target="_blank" :href="twUri"></a>
        <a class="sclItem wa" target="_blank" :href="waText"></a>
      </div>
      <div class="copy">
        &copy; Nutrilite Indonesia {{y}}
      </div>
    </div>
    <Main ref="main"/>
    <Faq ref="faq"/>
    <Video ref="video"/>
    <Download ref="download"/>
    <VideoThumb ref="videoThumb"/>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Video from '@/components/Video.vue';
import Main from '@/components/Main.vue';
import Faq from '@/components/Faq.vue';
import Download from '@/components/Download.vue';
import VideoThumb from '@/components/VideoThumb.vue';

export default {
  name: 'home',
  components: {
    Main,
    Faq,
    Video,
    Download,
    VideoThumb,
  },
  data() {
    return {
      y: '',
      name: '',
      titleAn: false,
      bubbleOpen: true,
      bubbleAn: true,
      bubbleCnt: true,
      openMenu: false,
      shareOpen: false,
    };
  },
  methods: {
    doNothing() {},
    openDownload() {
      this.openMenu = false;
      this.$refs.download.open();
    },
    openFaq() {
      this.openMenu = false;
      this.$refs.faq.open();
    },
    goBack() {
      window.history.back();
    },
    playVideo(name, thumb) {
      if (thumb) {
        this.$refs.videoThumb.open();
      } else {
        const d = {
          title: name,
          thumb,
          sources: [
            {
              src: `https://storage.googleapis.com/deepdivedjkt/clg/${name}-1080.mp4`,
              type: 'video/mp4',
              size: 1080,
            },
            {
              src: `https://storage.googleapis.com/deepdivedjkt/clg/${name}-720.mp4`,
              type: 'video/mp4',
              size: 720,
            },
            {
              src: `https://storage.googleapis.com/deepdivedjkt/clg/${name}-480.mp4`,
              type: 'video/mp4',
              size: 480,
            },
            {
              src: `https://storage.googleapis.com/deepdivedjkt/clg/${name}-360.mp4`,
              type: 'video/mp4',
              size: 360,
            },
          ],
        };
        this.$refs.video.open(d);
      }
    },
    toggleBubble() {
      if (!this.bubbleOpen) {
        this.bubbleAn = false;
        this.bubbleOpen = true;
        this.bubbleCnt = false;
        setTimeout(() => {
          this.bubbleAn = true;
        });
        setTimeout(() => {
          this.bubbleCnt = true;
        }, 200);
      } else {
        this.bubbleOpen = false;
      }
    },
  },
  computed: {
    ...mapState(['audioPlaying']),
    shareText() {
      return 'Yuk ikutan #YouthfuelSummerFest bersama @nutrilite_id';
    },
    twUri() {
      return 'https://twitter.com/intent/tweet?url='
        + `${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        + `&text=${escape(this.shareText)}&related=Amway,Nutrilite,Collagen`;
    },
    waText() {
      return 'https://api.whatsapp.com/send/?phone&text='
        + `${escape(`${this.shareText} di https://nutrilite.co.id/youthfuelsummerfest/`)}`
        + '&app_absent=0';
    },
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Beauty Inside Out - '
      + 'Youthfuel Summer Fest – Amunisi Segar Untuk Kulitmu';
    const d = new Date();
    this.y = d.getFullYear();
    this.name = localStorage.getItem('name');
    const token = localStorage.getItem('token');
    if (!token) {
      this.$refs.main.open((name) => {
        this.name = name;
      });
    }
    setTimeout(() => {
      this.titleAn = true;
    });
  },
};
</script>

<style scoped lang="scss">
section{
  background-color: #ffc9ca;
  background-image: linear-gradient(#ffc9ca, #fdbbce);
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  @media (max-width: 680px) {
    position: static;
  }
}
.menuCnt{
  position: fixed;
  right: 0; top: 0;
  overflow: hidden;
  height: 100px; width: 400px;
  z-index: 997;
}
.logo{
  width: 160px; height: 200px;
  background-color: green;
  margin: 20px auto;
}
.stages{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  position: absolute;
  top: 170px; left: 50%;
  z-index: 9;
  transform: translateX(-50%);
  flex-wrap: wrap;
  width: 1260px;
  margin: 0 -20px;
  @media (max-width: 1400px) {
    width: auto;
    left: 40px; right: 40px;
    transform: none;
  }
  @media (min-height: 800px) {
    top: 50%; transform: translate(-50%, -50%);
    margin-top: 40px;
  }
  @media (max-width: 1400px) and (min-height: 800px) {
    top: 50%; transform: translateY(-50%);
  }
  @media (max-width: 1169px) {
    left: 20px; right: 20px;
    top: 50%; transform: translateY(-50%);
    margin-top: 40px;
  }
  @media (max-width: 680px) {
    position: relative;
    transform: none;
    left: auto; top: auto; right: auto;
    display: block;
    transform: none;
    padding-top: 146px;
    margin: 0;
    min-height: 100vh;
    box-sizing: border-box;
  }
  .stageItem{
    width: 50%;
    position: relative;
    box-sizing: border-box;
    padding: 0 20px;
    @media (max-width: 680px) {
      width: auto;
      margin: 0 16px 40px;
      padding: 0;
    }
    .videoCnt{
      height: 340px;
      background-position: center;
      background-size: cover;
      cursor: pointer;
      transition: all .3s ease;
      border-radius: 10px;
      box-shadow: 2px 2px 8px rgba(0,0,0,.2);
      position: relative;
      &:before{
        content: "";
        width: 100px; height: 100px;
        background-image: url(../assets/play.png);
        background-size: 60px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        opacity: .8;
        transition: all .3s ease;
        top: 50%; left: 50%;
        margin: -50px 0 0 -50px;
      }
      &:hover{
        transform: scale(1.04);
        &:before{
          opacity: 1;
        }
      }
      @media (max-width: 1169px) {
        height: 260px;
      }
      @media (max-width: 680px) {
        height: 200px;
        transform: none !important;
      }
    }
    h4{
      text-align: center;
      margin: 20px 0 10px;
      font-family: CarlaSansBold;
      font-size: 24px;
      cursor: pointer;
      @media (max-width: 680px) {
        margin: 16px 0 0;
        font-size: 16px;
      }
    }
    &.stage1{
      .videoCnt{
         background-image: url(../assets/beauty-from-inside.jpg);
      }
    }
    &.stage2{
      .videoCnt{
         background-image: url(../assets/beauty-from-outside.jpg);
      }
    }
  }
  .stageAction{
  }
  .tide, .tideBg{
    display: none;
  }
  @media (max-width: 680px) {
    padding-bottom: 140px;
    overflow: hidden;
    position: relative;
    .tide, .tideBg{
      display: block;
    }
  }
}
.payungB{
  width: 280px; height: 280px;
  position: fixed;
  left: 50%; bottom: -160px;
  background-image: url(../assets/umbrela-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
  display: none;
  @media (max-width: 680px) {
    display: block;
    width: 140px; height: 140px;
    top: 50%; left: -80px; margin-top: -40px;
  }
}
.bolaPantai{
  width: 120px; height: 120px;
  position: fixed;
  right: -60px; top: 50%;
  transform: translateY(-50%);
  margin-top: -30px;
  background-image: url(../assets/bola-pantai.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 4;
  @media (max-width: 680px) {
    width: 80px; height: 80px;
    top: 300px; right: -40px;
  }
}

.title{
  width: 440px; height: 260px;
  position: absolute;
  left: 50%; top: -260px;
  background-image: url(../assets/beauty-title.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: -220px;
  z-index: 91;
  transition: all .3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &.an{
    top: -80px;
    @media (max-width: 680px) {
      top: -70px;
    }
  }
  @media (max-width: 680px) {
    width: 280px; margin-left: -140px;
  }
}

.recommender{
  position: fixed;
  right: 60px; bottom: 30px;
  width: 120px; height: 120px;
  background-image: url(../assets/umang-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 99;
  @media (max-width: 1169px) {
    right: 30px; bottom: 20px;
  }
  @media (max-width: 680px) {
    width: 60px; height: 60px;
    background-size: 40px auto;
    background-color: #ffecef;
    background-color: #ffecef;
    // background-color: #f8e051;
    border-radius: 30px 3px 30px 30px;
    box-shadow: 2px 2px 10px rgba(0,0,0,.4);
    right: 16px;
  }
  .bubble{
    position: absolute;
    right: 100%; bottom: 0;
    margin-bottom: 20px;
    margin-right: 40px;
    background-color: #ffecef;
    padding: 20px 24px 4px;
    border-radius: 10px;
    width: 340px;
    box-shadow: 2px 2px 6px rgba(0,0,0,.3);
    display: none;
    &.open{
      display: block;
    }
    @media (max-width: 1400px) {
      width: 300px;
      font-size: 14px;
    }
    @media (max-width: 680px) {
      background-color: #ffecef;
      display: none;
      right: 0; margin-bottom: 10px;
      bottom: 100%; margin-right: 0;
      border-radius: 15px 15px 0 15px;
      width: 260px; padding: 20px;
      // font-weight: normal;
      // opacity: 0;
      transition: all .2s ease;
      width: 20px; height: 20px;
      overflow: hidden;
      .bubbleContent{
        opacity: 0;
        transition: all .1s ease;
      }
      &.cnt{
        .bubbleContent{
          opacity: 1;
        }
      }
      &.open{
        display: block;
      }
      &.an{
        opacity: 1;
        transform: none;
        width: 260px; height: 250px;
      }
    }
    .bubbleContent{
      position: relative;
      z-index: 7;
      p{
        margin: 0 0 16px;
        @media (max-width: 680px) {
          margin-bottom: 10px;
        }
      }
    }
    .arrow{
      position: absolute;
      border-top: transparent 16px solid;
      border-bottom: transparent 16px solid;
      border-left: #ffecef 20px solid;
      right: -20px; bottom: 30px;
      z-index: 2;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .arrow2{
      position: absolute;
      border-bottom: transparent 20px solid;
      border-top: transparent 20px solid;
      border-left: #000 24px solid;
      right: -24px; bottom: 26px;
      z-index: 1;
      filter: blur(4px);
      opacity: .5;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .arrow3{
      position: absolute;
      bottom: 20px; height: 60px; width: 20px; right: 0;
      background-color: #ffecef;
      z-index: 3;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .btn{
      font-size: 14px;
      box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      @media (max-width: 680px) {
        font-size: 12px;
        padding: 10px 14px 7px;
      }
    }
  }
}

.tideBg{
  background-image: url(../assets/tide-bg-fliped.png);
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  position: absolute;
  left: -200px; right: 200px; bottom: -180px;
  height: 460px;
  transform: rotate(18deg);
  z-index: 1;
  @media (max-width: 1260px) {
    transform: rotate(20deg);
  }
  @media (max-width: 1024px) {
    right: 0; height: 400px;
  }
  @media (max-width: 680px) {
    height: 200px; bottom: 0;
    display: none;
  }
}
.tide{
  background-image: url(../assets/tide-fliped.png);
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  position: absolute;
  left: -200px; right: 200px; bottom: -260px;
  height: 460px;
  transform: rotate(14deg);
  animation: tideAn 10s infinite ease;
  z-index: 3;
  @media (max-width: 1260px) {
    transform: rotate(18deg);
  }
  @media (max-width: 1024px) {
    right: 0; height: 400px;
  }
  @media (max-width: 680px) {
    height: 200px; bottom: 0;
    animation: tideAnSm 10s infinite ease;
    display: none;
  }
  @keyframes tideAn {
    0% {bottom: -240px;}
    40% {bottom: -300px;}
    60% {bottom: -300px;}
    100% {bottom: -240px;}
  }
  @keyframes tideAnSm {
    0% {bottom: -60px;}
    40% {bottom: -110px;}
    60% {bottom: -110px;}
    100% {bottom: -60px;}
  }
}
.star1{
  width: 74px; height: 74px;
  position: fixed;
  left: 260px; bottom: 180px;
  background-image: url(../assets/star-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 40px; height: 40px;
    left: 20px; bottom: 80px;
  }
}
.star2{
  width: 74px; height: 74px;
  position: fixed;
  right: 36%; bottom: 260px;
  background-image: url(../assets/star-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 60px; height: 60px;
    bottom: 200px; right: 40px;
  }
}
.umang{
  width: 74px; height: 74px;
  position: fixed;
  left: -74px; bottom: 120px;
  background-image: url(../assets/kepiting-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: umangAn 65s infinite linear;
  z-index: 2;
  @media (max-width: 680px) {
    width: 40px; height: 40px;
    bottom: 80px;
  }
  @keyframes umangAn {
    from { left: -74px; }
    to { left: 110%; }
  }
}
.rumputL{
  width: 280px; height: 500px;
  position: fixed;
  left: 380px; top: -396px;
  background-image: url(../assets/rumput-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  @media (max-width: 1100px) and (max-height: 1100px) {
    height: 400px; top: -320px; left: 240px;
  }
  @media (max-width: 680px) {
    height: 240px;
    top: -180px; left: 60px;
    display: none;
  }
  &.rumputL2{
    background-image: url(../assets/rumput-r2.png);
    left: 600px;
    top: -420px;
  }
}
.rumputR{
  width: 280px; height: 500px;
  position: fixed;
  right: 260px; top: -396px;
  background-image: url(../assets/rumput-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  @media (max-width: 680px) {
    display: none;
  }
  &.rumputR2{
    background-image: url(../assets/rumput-l2.png);
    right: 460px;
    top: -420px;
    @media (max-width: 1600px) {
      display: none;
    }
  }
}
.lHeader{
  position: absolute;
  left: 0; right: 0; top: 0;
  overflow: hidden; height: 600px;
}
.leafL{
  width: 540px; height: 540px;
  position: fixed;
  left: -200px; top: -176px;
  background-image: url(../assets/leaf-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: l1An 10s infinite ease;
  z-index: 8;

  // Smaller leaf
  width: 480px; height: 480px;
  left: -160px; top: -160px;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    left: -140px; top: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    left: -80px; top: -80px;
  }
  @keyframes l1An {
    0% {transform: rotate(0deg);}
    10% {transform: rotate(0deg);}
    45% {transform: rotate(10deg);}
    55% {transform: rotate(10deg);}
    90% {transform: rotate(0deg);}
    100% {transform: rotate(0deg);}
  }
}
.leafR{
  width: 540px; height: 540px;
  position: fixed;
  right: -180px; top: -140px;
  background-image: url(../assets/leaf-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;

  width: 480px; height: 480px;
  right: -160px; top: -160px;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    right: -140px; top: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    right: -80px; top: -80px;
  }
}
@keyframes windAn {
  0% {transform: rotate(0deg);}
  10% {transform: rotate(0deg);}
  45% {transform: rotate(8deg);}
  55% {transform: rotate(8deg);}
  90% {transform: rotate(0deg);}
  100% {transform: rotate(0deg);}
}
</style>
